angular.module('bizmetryApp').controller('HomeController', function ($scope, $http, $location, CONFIG, $mdDialog, ProfileService,
  ConfigurationService, AuthService, dialogService,
  PlatformInfoService, $timeout,
  TemplateInstanceService, $mdToast, $sce, $rootScope
) {
  console.log("🏁 HomeController activo");

  $scope.currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');
  console.log("✅ currentUser>>>>>>> :", $scope.currentUser);


  // ✅ LISTENER PARA ACTUALIZAR EL USUARIO CUANDO SE EDITA EL PERFIL
  $rootScope.$on('user:profileUpdated', function (event, updatedData) {
    console.log('🔄 Home: User profile updated event received:', updatedData);

    if ($scope.currentUser) {
      $scope.currentUser.firstName = updatedData.firstName;
      $scope.currentUser.lastName = updatedData.lastName;
      console.log('✅ Home: currentUser updated:', $scope.currentUser);
    }
  });

  $scope.profiles = [];

  var defaultLength = 20;

  $scope.config = {
    truncate: {
      profileName: ConfigurationService.getFromCache('frontend.home.cards.card_title_max_length') || defaultLength,
      projectName: ConfigurationService.getFromCache('frontend.home.cards.card_project_max_length') || defaultLength,
      description: ConfigurationService.getFromCache('frontend.home.cards.card_description_max_length') || defaultLength,
      bizDomain: ConfigurationService.getFromCache('frontend.home.cards.card_bizdomain_max_length') || defaultLength,
      techStack: ConfigurationService.getFromCache('frontend.home.cards.card_techstack_max_length') || defaultLength,
      language: ConfigurationService.getFromCache('frontend.home.cards.card_language_max_length') || defaultLength,
      templateName: ConfigurationService.getFromCache('frontend.home.cards.card_template_name_max_length') || defaultLength,
      createdBy: ConfigurationService.getFromCache('frontend.home.cards.card_createdby_max_length') || defaultLength
    }
  };

  $scope.logout = function () {
    localStorage.removeItem("auth_token");
    sessionStorage.removeItem("user");
    $location.path('/login');
  };

  $scope.getCardColor = function (profile) {
    const pastelColors = [
      '#FFEBEE', '#E3F2FD', '#F3E5F5', '#E8F5E9',
      '#FFF8E1', '#FBE9E7', '#E0F7FA'
    ];
    const hash = Array.from(profile.id).reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return pastelColors[hash % pastelColors.length];
  };

  $scope.getAccountTypeColor = function (accountTypeName) {
    const hash = accountTypeName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const palette = ['#1976d2', '#d32f2f', '#388e3c', '#f57c00', '#7b1fa2', '#0097a7'];
    return palette[hash % palette.length];
  };

  $scope.editProfile = function (profile) {
    console.log("✏️ Edit profile:", profile);
  };

  $scope.showProfileDetails = function (profile, tabIndex) {
    let profileNow = null;
    let templateNow = null;

    ProfileService.getProfileById(profile.id)
      .then(function (response) {
        profileNow = response.data;
        return TemplateInstanceService.getTemplateInstanceById(profileNow.templateId);
      })
      .then(function (response) {
        templateNow = response.data;

        return $mdDialog.show({
          controller: 'ProfileDetailsDialogController',
          templateUrl: 'profile/profile-details-dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          escapeToClose: false,
          locals: {
            profile: profileNow,
            template: templateNow,
            initialTabIndex: tabIndex || 0
          }
        });
      })
      .catch(function (err) {
        // $mdDialog.show() rejects with no payload when the dialog is cancelled — not an error.
        if (!err) return;
        console.error('❌ Failed to retrieve data:', err);
        const reason = err.data && (err.data.message || err.data.error);
        // showErrorDialog renders trusted HTML → escape the API text.
        const escaped = reason && angular.element('<div>').text(reason).html();
        dialogService.showErrorDialog(
          err.status === 403 ? 'Access Denied' : 'Data Retrieval Error',
          'An error occurred while fetching the profile or template details.' +
            (escaped ? '<br><br><strong>Reason:</strong> ' + escaped : '<br>Please try again later.')
        );
      })
      .finally(function () {
        if (typeof $scope.fetchProfiles === 'function') {
          $scope.fetchProfiles();
        }
      });
  };

  $scope.openProfileDetails = function (profile, tabIndex) {
    $scope.selectedProfile = profile;
    $scope.selectedTabIndex = tabIndex;
    $scope.showProfileDetails(profile, tabIndex);
  };

  $scope.openApiCollectionsDialog = function (ev) {
    $mdDialog.show({
      controller: 'ApiCollectionsDialogController',
      templateUrl: 'home/main-menu/api-collection/api-collection-dialog.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true,
      escapeToClose: false,
      fullscreen: false,
      multiple: true,
      locals: { sessionInfo: $scope.currentUser }
    });
  };

  $scope.toggleProfileEnabled = function (profile) {
    profile.loading = true;

    $http({
      method: 'PATCH',
      url: `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profile.id}`,
      headers: {
        'Content-Type': 'application/json',
        'X-User-Account-Id': $scope.currentUser.id
      },
      data: { isEnabled: profile.isEnabled },
      bmSkipLoader: true
    })
      .then(function (response) {
        console.log("✅ Profile isEnabled actualizado:", response.data);
      })
      .catch(function (error) {
        console.error("❌ Error actualizando isEnabled:", error);
        profile.isEnabled = !profile.isEnabled;
      })
      .finally(function () {
        profile.loading = false;
      });
  };

  $scope.deleteProfile = function (profile) {
    dialogService.showConfirmationDialog(
      'Delete Profile',
      `Are you sure you want to delete profile "<strong>${profile.profileName}</strong>"? All associated configurations including templates and agents will be <strong>irreversibly destroyed</strong> and <strong>permanently discarded</strong>.<br><br>Before proceeding, make sure you have backed up your profile configuration if needed.`,
      profile.profileName,
      true
    ).then(function (decision) {
      if (decision === 'confirmed') {
        ProfileService.deleteProfile(profile.id)
          .then(function () {
            $scope.profiles = $scope.profiles.filter(p => p.id !== profile.id);
            $mdToast.show(
              $mdToast.simple()
                .textContent(`✅ Profile "${profile.profileName}" deleted successfully`)
                .position('top right')
                .hideDelay(3000)
            );
          })
          .catch(function (error) {
            console.error('❌ Failed to delete profile:', error);
            var errorMessage = 'Failed to delete profile. Please try again.';
            if (error.data) {
              errorMessage = (error.data.error && error.data.message)
                ? dialogService.formatErrorMessage(error.data)
                : (error.data.message || errorMessage);
            }
            dialogService.showErrorDialog('Delete Failed', errorMessage);
          });
      }
    });
  };

  $scope.cloneProfile = function (profile) {
    $http({
      method: 'POST',
      url: `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profile.id}/clone`,
      headers: {
        'Content-Type': 'application/json',
        'X-User-Account-Id': $scope.currentUser.id
      }
    })
      .then(function (response) {
        $scope.profiles.push(response.data);
        $mdToast.show(
          $mdToast.simple()
            .textContent(`✅ Profile Cloned Successfully`)
            .position('top right')
            .hideDelay(3000)
        );
      })
      .catch(function (err) {
        console.error('❌ Clone failed', err);
        const backendMsg =
          (err && err.data && (err.data.message || err.data.error)) ||
          (err && err.status ? `HTTP ${err.status} ${err.statusText || ''}`.trim() : null) ||
          'Failed to clone the profile. Please try again later.';
        dialogService.showErrorDialog('Profile Clone Error', backendMsg);
      });
  };

  $scope.openDatasourceDialog = function () {
    $mdDialog.show({
      controller: 'DatasourceDialogController',
      templateUrl: 'home/main-menu/datasources/summary/datasource-dialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      escapeToClose: false,
      fullscreen: true
    });
  };

  $scope.openResourcesDialog = function () {
    return $mdDialog.show({
      controller: 'ResourceExplorerDialogController', controllerAs: 'vm',
      templateUrl: 'profile/tabs/resources/resource-explorer/resource-explorer-dialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false, escapeToClose: false,
      locals: { profile: null, resourceTypeId: '' }
    });
  };

  $scope.openJobsDialog = function () {
    $mdDialog.show({
      controller: 'JobDefinitionsDialogController',
      templateUrl: 'home/main-menu/jobs/job-definitions-dialog.html',
      parent: angular.element(document.body),
      escapeToClose: false,
      clickOutsideToClose: true
    });
  };

  $scope.platformInfo = PlatformInfoService.getPlatformInfo();

  $scope.openNotificationsDialog = function (ev) {
    $mdDialog.show({
      controller: 'NotificationsDialogController',
      templateUrl: '/home/main-menu/notifications/view-notifications-dialog.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      escapeToClose: false,
      clickOutsideToClose: true,
      fullscreen: true
    });
  };

  $scope.openAgentsDialog = function (ev) {
    $mdDialog.show({
      controller: 'AgentsPanelController',
      templateUrl: 'home/main-menu/agent-panel/agents-panel.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      escapeToClose: false,
      clickOutsideToClose: true,
      fullscreen: true
    });
  };

  $scope.openInterceptorsDialog = function (ev) {
    $mdDialog.show({
      controller: 'InterceptorsPanelController',
      templateUrl: 'home/main-menu/interceptor-panel/interceptors-panel.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      escapeToClose: false,
      clickOutsideToClose: true,
      fullscreen: true
    });
  };

  $scope.deleteAccount = function () {
    $scope.currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');
    var orgName = $scope.currentUser.orgName || 'organization';

    dialogService.showConfirmationDialog(
      'Delete Account',
      'Are you sure you want to delete your account? All related configurations will be <strong>irreversibly destroyed</strong>, and all agents shall be <strong>decommissioned and retired</strong>, making them unusable.<br><br>Before proceeding, make sure you have backed up your account by using the Export option.',
      orgName,
      true
    ).then(function (decision) {
      if (decision === 'confirmed') {
        AuthService.deleteAccount($scope.currentUser.id)
          .then(function () {
            dialogService.showSuccessDialog('Account Deleted', 'Your account has been successfully deleted.')
              .then(function () {
                sessionStorage.clear();
                $location.path('/login');
              });
          })
          .catch(function (error) {
            console.error('❌ Failed to delete account:', error);
            var errorMessage = 'Failed to delete account. Please try again.';
            if (error.data) {
              errorMessage = (error.data.error && error.data.message)
                ? dialogService.formatErrorMessage(error.data)
                : (error.data.message || errorMessage);
            }
            dialogService.showErrorDialog('Delete Failed', errorMessage);
          });
      }
    });
  };

  $scope.openCreateProfileWizard = function (ev) {
   
    $mdDialog.show({
      controller: 'CreateProfileWizardController',
      templateUrl: 'home/main-menu/create-profile/create-profile-wizard.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      escapeToClose: false,
      fullscreen: false
    })
      .then(function () {
        $scope.fetchProfiles();
      })
      .catch(function () { })
      .finally(function () {
     
      });
  };

  $scope.logout = function () {
    dialogService.showDecisionDialog('Logout Confirmation', 'Are you sure you want to terminate the session?')
      .then(function (decision) {
        if (decision === 'proceed') {
          AuthService.logout()
            .then(function () { $location.path('/login'); })
            .catch(function (error) { console.error('Logout failed:', error); });
        }
      });
  };

  function mapSort(selectedSort) {
    switch (selectedSort) {
      case 'NAME_ASC': return { criteria: 'profileName', direction: 'ASC' };
      case 'NAME_DESC': return { criteria: 'profileName', direction: 'DESC' };
      case 'PROJECT_ASC': return { criteria: 'projectName', direction: 'ASC' };
      case 'PROJECT_DESC': return { criteria: 'projectName', direction: 'DESC' };
      case 'CREATED_ASC': return { criteria: 'createdTs', direction: 'ASC' };
      case 'CREATED_DESC': return { criteria: 'createdTs', direction: 'DESC' };
      default: return { criteria: 'createdTs', direction: 'DESC' };
    }
  }

  let debounceTime = ConfigurationService.getFromCache('frontend.search_debounce_time');
  let defaultPageSize = ConfigurationService.getFromCache('frontend.profile_page_size');
  let defaultSortCriteria = ConfigurationService.getFromCache('frontend.profile_sort_criteria');

  $scope.searchText = '';
  $scope.selectedSort = defaultSortCriteria;
  $scope.paging = {
    pageOffset: 0,
    pageSize: defaultPageSize || 10,
    pageCount: 0
  };
  $scope.loading = false;
  $scope.profiles = [];

  let searchDebouncePromise = null;

  $scope.fetchProfiles = function () {
    $scope.loading = true;
    var sort = mapSort($scope.selectedSort);

    ProfileService.getAllProfiles({
      sortCriteria: sort.criteria,
      sortDirection: sort.direction,
      page: $scope.paging.pageOffset,
      size: $scope.paging.pageSize,
      search: $scope.searchText && $scope.searchText.trim() ? $scope.searchText.trim() : null
    })
      .then(function (res) {
        if (res.data) {
          $scope.profiles = res.data.profiles || {};
          $scope.paging = res.data.paging || {};
        }
      })
      .catch(function (err) { console.error('❌ Error loading profiles:', err); })
      .finally(function () { $scope.loading = false; });
  };

  $scope.onSortChange = function () {
    $scope.paging.pageOffset = 0;
    $scope.fetchProfiles();
  };

  $scope.changePageSize = function () {
    $scope.paging.pageOffset = 0;
    $scope.fetchProfiles();
  };

  $scope.onSearchChange = function () {
    if (searchDebouncePromise) $timeout.cancel(searchDebouncePromise);
    searchDebouncePromise = $timeout(function () {
      $scope.paging.pageOffset = 0;
      $scope.fetchProfiles();
    }, debounceTime);
  };

  $scope.fetchProfiles();

  $scope.clearFilters = function () {
    $scope.selectedSort = '';
    $scope.searchText = '';
    $scope.paging.pageOffset = 0;
    $scope.paging.pageSize = defaultPageSize;
    $scope.fetchProfiles();
  };

  $scope.pageInputDisplay = $scope.paging.pageOffset + 1;

  $scope.goFirst = function () { if ($scope.paging.pageOffset > 0) { $scope.paging.pageOffset = 0; $scope.fetchProfiles(); } };
  $scope.goPrev = function () { if ($scope.paging.pageOffset > 0) { $scope.paging.pageOffset--; $scope.fetchProfiles(); } };
  $scope.goNext = function () { if ($scope.paging.pageOffset < ($scope.paging.pageCount - 1)) { $scope.paging.pageOffset++; $scope.fetchProfiles(); } };
  $scope.goLast = function () { if ($scope.paging.pageOffset < ($scope.paging.pageCount - 1)) { $scope.paging.pageOffset = $scope.paging.pageCount - 1; $scope.fetchProfiles(); } };

  $scope.openDocumentation = function (ev) {
    var docUrl = ConfigurationService.getFromCache('bizmetry.urls.docs_base_url') || 'https://docs.bizmetry.io';
    $mdDialog.show({
      controller: function ($scope, $mdDialog, $sce) {
        $scope.docUrl = $sce.trustAsResourceUrl(docUrl);
        $scope.closeDialog = function () { $mdDialog.hide(); };
      },
      template: `
        <md-dialog aria-label="BizMetry Help" style="width: 90vw; max-width: 1400px; height: 80vh;">
          <md-toolbar class="md-primary" style="color: white; background-color: #1976d2;">
            <div class="md-toolbar-tools">
              <h2 style="font-weight: 500; color: white;">BizMetry Help</h2>
              <span flex></span>
              <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close">
                <md-icon class="material-icons" style="color: white;">close</md-icon>
              </md-button>
            </div>
          </md-toolbar>
          <md-dialog-content style="height: calc(100% - 64px); padding: 0;">
            <iframe ng-src="{{docUrl}}" style="width:100%; height:100%; border:0;"></iframe>
          </md-dialog-content>
        </md-dialog>`,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true
    });
  };

  $scope.openUsersDialog = function (ev) {
    $mdDialog.show({
      controller: 'UsersRolesDialogController',
      templateUrl: 'home/main-menu/users/user-management-dialog.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      escapeToClose: false,
      clickOutsideToClose: false,
      fullscreen: false,
      multiple: true,
      locals: { accountId: $scope.currentUser.id }
    });
  };

  $scope.openUserProfileDialog = function (ev) {
    $mdDialog.show({
      controller: 'UserProfileDialogController',
      templateUrl: 'home/user-profile/user-profile-dialog.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true,
      escapeToClose: true,
      multiple: true,
      locals: { currentUser: $scope.currentUser }
    });
  };

  $scope.openEditOrganizationDialog = function (ev) {
    $scope.currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');

    $mdDialog.show({
      controller: 'EditOrganizationDialogController',
      templateUrl: 'home/user-profile/edit-organization/edit-organization-dialog.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true,
      escapeToClose: true,
      multiple: true,
      locals: {
        accountId: $scope.currentUser.id,
        currentData: {
          organizationName: $scope.currentUser.orgName || '',
          accountTypeId: $scope.currentUser.accountTypeId || null,
          accountTypeName: $scope.currentUser.accountTypeName || '',
          countryId: $scope.currentUser.countryId || null,
          countryName: $scope.currentUser.countryName || '',
          stateId: $scope.currentUser.stateId || null,
          stateName: $scope.currentUser.stateName || ''
        }
      }
    }).then(function (updatedData) {
      if (updatedData) {
        $scope.currentUser.orgName = updatedData.organizationName;
        $scope.currentUser.accountTypeId = updatedData.accountTypeId;
        $scope.currentUser.accountTypeName = updatedData.accountTypeName;
        $scope.currentUser.countryId = updatedData.countryId;
        $scope.currentUser.stateName = updatedData.stateName;
        sessionStorage.setItem('user', JSON.stringify($scope.currentUser));
      }
    });
  };

});